"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModel = void 0;
var tslib_1 = require("tslib");
var form_1 = require("../form");
var brightnessCorrection_state_1 = require("./brightnessCorrection/brightnessCorrection.state");
var collection_base_1 = require("./collection.base");
var collection_loader_1 = require("./collection.loader");
var collection_state_1 = require("./collection.state");
var cropParameter_state_1 = require("./cropParameter/cropParameter.state");
var drawable_state_1 = require("./drawable/drawable.state");
var capture_provider_1 = require("./fields/provider/capture.provider");
var collection_provider_1 = require("./fields/provider/collection.provider");
var imageVisibility_state_1 = require("./imageVisibility/imageVisibility.state");
/**
 * This class is a proxy to store all its data inside of the state.
 *
 * This is done to allow a easy place to record all changes to the Collection,
 * which can be used for editing, undo/redo stacks.
 *
 * **Do not** add any properties directly to this class
 */
var CollectionModel = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModel, _super);
    function CollectionModel(form, loader) {
        var _this = _super.call(this, null, null, form) || this;
        _this.drawableState = {};
        _this.brightnessCorrectionState = {};
        _this.cropParameterState = {};
        _this.imageVisibilityState = {};
        _this._fieldCache = {};
        _this._fieldCacheCount = 0;
        _this.loader = loader;
        return _this;
    }
    CollectionModel.createLoader = function () {
        return new collection_loader_1.IkeCollectionLoaderFromState();
    };
    Object.defineProperty(CollectionModel.prototype, "state", {
        get: function () {
            if (this.isEditing) {
                return this.proxyState;
            }
            if (this._state == null) {
                this._state = new collection_state_1.CollectionModelState(this.loader);
            }
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "id", {
        get: function () { return this.state.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "instanceId", {
        get: function () { return this.state.instanceId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "uuid", {
        get: function () { return this.state.uuid; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "revision", {
        get: function () { return this.state.revision; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "jobId", {
        get: function () { return this.state.jobId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "updatedAt", {
        get: function () { return this.state.updatedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "updatedBy", {
        get: function () { return this.state.updatedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "createdAt", {
        get: function () { return this.state.createdAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collectedBy", {
        get: function () { return this.state.collectedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collectedWith", {
        get: function () { return this.state.collectedWith; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "assignedTo", {
        get: function () { return this.state.assignedTo; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collectedAt", {
        get: function () {
            if (this.state.collectedAt != null) {
                return this.state.collectedAt;
            }
            var captureIds = capture_provider_1.CaptureProvider.getCaptureIds(this);
            var earliestDate = null;
            for (var _i = 0, captureIds_1 = captureIds; _i < captureIds_1.length; _i++) {
                var captureId = captureIds_1[_i];
                var fetchable = this.loader.Capture.getById(captureId);
                // Only calculate when all captures are loaded
                if (!fetchable.hasFetched) {
                    return null;
                }
                var capture = fetchable.value;
                if (capture.collectedAt == null) {
                    continue;
                }
                if (earliestDate == null || capture.collectedAt.iso < earliestDate) {
                    earliestDate = capture.collectedAt.iso;
                }
            }
            if (earliestDate != null) {
                this.state.collectedAt = new Date(earliestDate);
            }
            return this.state.collectedAt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "status", {
        /**
         * Look up the collection status using the status field from the metadata.
         *
         * If the collection does not have a status field, no field will be returned.
         */
        get: function () {
            var statusField = this.schema.metadata.getStatusField();
            if (statusField == null) {
                return null;
            }
            return this.getField(statusField.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "mapMarkerColor", {
        /**
         * Look up the collection map color using the map color field from the metadata.
         * If the collection does not have a map color field, no field will be returned.
         */
        get: function () {
            var mapColorField = this.schema.metadata.getMapColorField();
            if (mapColorField == null) {
                return null;
            }
            var color = null;
            if (mapColorField instanceof form_1.FormModelFieldSelectList) {
                color = mapColorField.options[0].color;
                var field_1 = this.getField(mapColorField.id);
                if (field_1) {
                    mapColorField.options.forEach(function (option) {
                        if (option.value === field_1.value) {
                            color = option.color;
                        }
                    });
                }
            }
            else if (mapColorField instanceof form_1.FormModelFieldNestedList) {
                var field = this.getField(mapColorField.id);
                color = '#a0aec0';
                if (field) {
                    if (field.hasValue()) {
                        for (var i = 0; i < mapColorField.options.values.length; i++) {
                            if (mapColorField.options.values[i].value === field.value[0]) {
                                color = mapColorField.options.values[i].color;
                            }
                        }
                    }
                }
            }
            return color;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new proxy state layer, this can be used to track changes to a collection.
     * @returns Created proxy state
     */
    CollectionModel.prototype.beginEdit = function (editState) {
        var newState = editState(this._state);
        this.proxyState = newState;
        return newState;
    };
    /**
     * Remove the proxy state layer, this will undo any changes made to a collection
     */
    CollectionModel.prototype.finishEdit = function () {
        if (this.proxyState == null) {
            throw new Error('Unable to finish editing, no edit in place');
        }
        this.proxyState = null;
    };
    Object.defineProperty(CollectionModel.prototype, "isEditing", {
        get: function () {
            return this.proxyState != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "collection", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModel.prototype, "recordedAt", {
        /**
         * Get the time the collection was created, using the collectedAt if it exists otherwise the time it was uploaded
         */
        get: function () {
            return this.collectedAt == null ? this.createdAt : this.collectedAt;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModel.prototype.getDrawableState = function (captureId) {
        var existing = this.drawableState[captureId];
        if (existing == null) {
            existing = this.drawableState[captureId] = new drawable_state_1.CollectionModelDrawableState(this, captureId);
        }
        return existing;
    };
    CollectionModel.prototype.getImageVisibilityState = function (captureId) {
        var existing = this.imageVisibilityState[captureId];
        if (existing == null) {
            existing = this.imageVisibilityState[captureId] = new imageVisibility_state_1.CollectionModelImageVisibilityState(this, captureId);
        }
        return existing;
    };
    CollectionModel.prototype.getBrightnessCorrectionState = function (captureId) {
        var existing = this.brightnessCorrectionState[captureId];
        if (existing == null) {
            existing = this.brightnessCorrectionState[captureId] = new brightnessCorrection_state_1.CollectionModelBrightnessCorrectionState(this, captureId);
        }
        return existing;
    };
    CollectionModel.prototype.getCropParameterState = function (captureId) {
        var existing = this.cropParameterState[captureId];
        if (existing == null) {
            existing = this.cropParameterState[captureId] = new cropParameter_state_1.CollectionModelCropParameterState(this, captureId);
        }
        return existing;
    };
    /**
     * Find a field using its unique field Id
     * Used for quickly looking up field links.
     *
     * @param fieldId Unique field Id including subformId
     * @returns collection field if it exists
     */
    CollectionModel.prototype.findField = function (fieldId) {
        var existing = this._fieldCache[fieldId];
        if (existing !== undefined) {
            return existing;
        }
        var output = null;
        this.forEachField(function (field) {
            if (field.id === fieldId) {
                output = field;
                return false; // abort the search
            }
            return true;
        });
        this._fieldCache[fieldId] = output;
        this._fieldCacheCount++;
        // Paranoia incase the cache gets too large
        if (this._fieldCacheCount > 1000) {
            this._fieldCacheCount = 0;
            this._fieldCache = {};
        }
        return output;
    };
    /**
     * Collections are not loaded with all their information.
     *
     * Wait for all the linked data to load in
     *
     * If any object in the returned list is null, it means the collection failed to load something.
     *
     * @return List of objects that were loaded
     */
    CollectionModel.prototype.ready = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var captureIds, collectionIds, fetchables, captures, i, capture, _i, collectionIds_1, collectionId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        captureIds = capture_provider_1.CaptureProvider.getCaptureIds(this);
                        collectionIds = collection_provider_1.CollectionProvider.getCollectionIds(this);
                        fetchables = [];
                        return [4 /*yield*/, Promise.all(captureIds.map(function (id) { return _this.loader.Capture.getById(id).fetch(); }))];
                    case 1:
                        captures = _a.sent();
                        for (i = 0; i < captures.length; i++) {
                            capture = captures[i];
                            if (capture == null) {
                                throw new Error('Unable to load capture: ' + captureIds[i]);
                            }
                            if (capture.calibrationid == null) {
                                continue;
                            }
                            fetchables.push(this.loader.Calibration.getById(capture.calibrationid).fetch());
                        }
                        for (_i = 0, collectionIds_1 = collectionIds; _i < collectionIds_1.length; _i++) {
                            collectionId = collectionIds_1[_i];
                            fetchables.push(this.loader.CollectionSummary.getById(collectionId).fetch());
                        }
                        return [4 /*yield*/, Promise.all(fetchables)];
                    case 2: 
                    // Note: We could fetch all linked collection models here, but if we did, it would
                    // recursively load all of the linked collections, which may trigger an infinite loop or
                    // an unnecessarily large number of fetches.
                    // So if you need to load linked collection models, use `CollectionModelState.getCollectionModelAsync()`
                    // or `CollectionModelFieldVector.getLinkedCollection()`.
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CollectionModel;
}(collection_base_1.CollectionModelBase));
exports.CollectionModel = CollectionModel;
//# sourceMappingURL=collection.data.js.map